// extracted by mini-css-extract-plugin
export var miniContainer = "MiniHeader-module--miniContainer--MmWyv";
export var miniHeadline = "MiniHeader-module--miniHeadline--H6IRA";
export var miniWrapper = "MiniHeader-module--miniWrapper--YqRRr";